<template>
  <v-row class="col-12 px-5 align-center">
    <v-textarea
      v-if="!hideComment"
      v-model="transaction.comment"
      label="Comment"
      small
      outlined
      auto-grow
      rows="1"
      :readonly="readonly"
      hide-details
      class="col-12 no-resize mb-2"
    />

    <template v-if="projectHasAccountMessages">
      <v-text-field
        v-model="transaction.details.account_message.status_message"
        :class="hideComment ? 'col-12 mb-2' : 'col-5'"
        outlined
        label="Message for Account"
        :readonly="readonly"
        hide-details
      >
        <template #prepend-inner>
          <v-menu offset-y max-height="400">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                small
                v-bind="attrs"
                v-on="on"
                class="px-0"
                style="min-width: 20px; margin-right: 3px"
              >
                <v-icon>keyboard_arrow_down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="preset in messagePresets"
                :key="preset.message + preset.type"
                :input-value="transaction.details.account_message.status_message === preset.message"
                @click="$emit('select-preset', preset)"
              >
                <v-list-item-title>
                  {{ preset.message }}
                  <span style="float: right" v-text="preset.type" />
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-text-field>

      <v-select
        v-model="transaction.details.account_message.message_type"
        :class="hideComment ? 'col-6 ml-0' : 'col-2 ml-2'"
        label="Message Type"
        :items="['alert', 'estimate', 'info']"
        outlined
        :readonly="readonly"
        hide-details
      />

      <v-switch
        v-model="transaction.details.account_message.display_to_account"
        class="col-auto mt-0"
        :class="hideComment ? 'col-5' : 'col-3'"
        label="Display message to account"
        :disabled="!transaction.details.account_message.status_message"
        :readonly="readonly"
        hide-details
      />
    </template>
  </v-row>
</template>

<script>
export default {
  props: {
    transaction: {
      type: Object,
      required: true,
    },
    isLoading: Boolean,
    messagePresets: {
      type: Array,
      required: true,
    },
    hideComment: Boolean,
    projectHasAccountMessages: Boolean,
    readonly: Boolean,
  },

  emits: [ 'select-preset' ],

  watch: {
    'transaction.details.account_message.status_message' (v) {
      if (!v) {
        this.transaction.details.account_message.display_to_account = false
      }
    },
  }
}
</script>
